import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Intent, IntentTransfer } from "@/model";
import intentRepository from "@/repository/intentRepository";
import { skillQueryKeys } from "@/query/skill";
import { intentQueryKeys } from "./keys";


export const useTransferIntent = (agentId: number, skillId?: number) => {
    const queryClient = useQueryClient();

    return useMutation<Intent, AxiosError, IntentTransfer>({
        mutationKey: ["intent", "agent", agentId, "skill", skillId, "intent-transfer"],
        mutationFn: async (body: IntentTransfer) => {
            try {
                const { data } = await intentRepository.transfer(agentId, skillId!, body);
                return data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: intentQueryKeys.intentsAll(agentId)
            });
            await queryClient.invalidateQueries({
                queryKey: skillQueryKeys.all(agentId),
            });
        }
    });
};
